import "../template.css";
import "../fontawesome-min.css";
import "../themify.css";
import "../bulk-style.css";
import "../iconly-icon.css";
import "../custom.css";
import "../vendors/weather-icons/weather-icons.min.css";
import "../vendors/scrollbar.css";
import "../vendors/slick.css";
import "../vendors/slick-theme.css";
import "../vendors/flag-icon.css";

import PageBody from "../PageBody";
import Clients from "../components/pages/Clients";

const ClientsPage = () => {
  return (
    <PageBody>
      <Clients />
    </PageBody>
  );
};

export default ClientsPage;
